/// Shared copy for the dataset release/publish flow, kept in one place so the
/// Datasets list and the share dialog can't drift apart.

/// Helper shown under the release-name composer.
export const RELEASE_COMPOSER_HELPER =
  "Releases each table's current version · Esc to close";

/// Map the server's release 409/400 error codes to a friendly message.
export const releaseErrorMessage = (e: unknown): string => {
  const data = (
    e as {
      response?: {
        data?: { error?: string; reason?: string; members?: string[] };
      };
    }
  )?.response?.data;
  switch (data?.error) {
    case "nothing_changed":
      return "No member has changed since the last release.";
    case "label_exists":
      return "A release with that label already exists.";
    case "external_members_unreleased":
      return `Imported members have no source release: ${(data.members ?? []).join(", ")}. Ask their owner to release first.`;
    case "no_members":
      return "Add tables to the dataset before releasing.";
    case "invalid_label":
      return data.reason ?? "Invalid release label.";
    default:
      return "Failed to release dataset.";
  }
};
